import React from 'react';
import Box from 'src/components-v2/Layout/Box/Box';
import SxProps from 'threads5/themes/sx-props';
import type { ITheme } from 'threads5/themes/theme';

interface Props {
  sx?: SxProps<ITheme>;
  containerSx?: SxProps<ITheme>;
  glowSx?: SxProps<ITheme>;
  isLazy?: boolean;
}

const GlowingCard: React.FC<React.PropsWithChildren<Props>> = React.forwardRef(
  ({ sx, containerSx, glowSx, children, isLazy }, ref) => {
    return (
      <Box
        component='section'
        sx={{
          height: '100vh',
          ...containerSx,
        }}
        ref={ref}
      >
        <Box
          sx={{
            display: 'flex',
            position: 'absolute',
            top: 0,
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            width: '100%',
            zIndex: 100,
            overflow: 'hidden',
            borderRadius: '40px',
            boxShadow: '0px 0px 70px 0px rgba(139, 139, 249, 0.70)',
            ...sx,
          }}
        >
          {children}
        </Box>
      </Box>
    );
  },
);

export default GlowingCard;
